import { useTranslation } from "@repo/translation";
import { logError, parseIsoDate } from "@repo/utils";
import { type Locale } from "date-fns";

import { localizeDate } from "./LocalizedDate";
import { localizeTime } from "./LocalizedTime";

interface Props {
  date: string | Date;
  timezone?: string;
  showYear?: boolean;
}

export const LocalizedDateAndTime = ({
  date,
  timezone,
  showYear = true,
}: Props) => {
  const { dateFnsLocale } = useTranslation();
  return <>{localizeDateAndTime(date, dateFnsLocale, timezone, showYear)}</>;
};

export const localizeDateAndTime = (
  date: string | Date,
  dateFnsLocale?: Locale,
  timezone?: string,
  showYear = true
) => {
  try {
    const d = parseIsoDate(date);
    if (!d) {
      return "-";
    }

    return `${localizeDate(d, dateFnsLocale, timezone, showYear)}, ${localizeTime(
      d,
      dateFnsLocale,
      timezone
    )}`;
  } catch (e) {
    logError(e, [{ tagName: "date", tagValue: date?.toString() }]);
    return "-";
  }
};
